import { useMatch, useNavigate } from "react-router-dom";
import Modal from "../Modal";

/**
 * Like <Route> but renders the element inside a <Modal>.
 * Place it alongside your <Routes> block (not inside it).
 * When the modal closes, navigates to parentPath.
 *
 * Usage:
 *   <ModalRoute
 *     path="/audience/:h/patterns/:type/:id/*"
 *     parentPath="/audience/:h/patterns"
 *     element={<Detail />}
 *     maxWidth="max-w-4xl"
 *   />
 */
const ModalRoute = ({ path, parentPath, element, maxWidth, heightClass, noPadding }) => {
  const navigate = useNavigate();
  const match = useMatch({ path, end: false });

  if (!match) return null;

  const onClose = () => navigate(parentPath, { replace: true });

  return (
    <Modal maxWidth={maxWidth} heightClass={heightClass} onClose={onClose} noPadding={noPadding}>
      {element}
    </Modal>
  );
};

export default ModalRoute;
